import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';

interface MailingOption {
  id: string;
  name: string;
}

interface MailingFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

const mailingOptions: MailingOption[] = [
  { id: 'true', name: 'Opted-In' },
  { id: 'false', name: 'NOT Opted-In' },
];

export const MailingFilter: React.FC<MailingFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedOption = mailingOptions.find((o) => o.id === value);

  if (valueOnly) {
    return <>{selectedOption?.name || ''}</>;
  }

  return (
    <Autocomplete
      options={mailingOptions}
      getOptionLabel={(option) => option.name}
      value={selectedOption || null}
      onChange={(_, newValue) => {
        setValue(newValue?.id || '');
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Select Mailing Status"
        />
      )}
    />
  );
};
